import { Routes } from '@angular/router';

import { DashboardComponent } from '../../pages/dashboard/dashboard.component';
import { ListComponent } from '../../pages/list/list.component';
import { SettingsComponent } from '../../pages/settings/settings.component';
import { MapsComponent } from '../../pages/maps/maps.component';
import { LoginComponent } from '../../pages/login/login.component';
import { SignUpComponent } from '../../pages/sign-up/sign-up.component';

export const AdminLayoutRoutes: Routes = [
    { path: 'dashboard',      component: DashboardComponent },
    { path: 'login',          component: LoginComponent },
    { path: 'finishsignup',   component: SignUpComponent },
    { path: 'list',           component: ListComponent },
    { path: 'settings',       component: SettingsComponent },
    { path: 'maps',           component: MapsComponent }
];
